import "~/bootstrap/page/product_line.scss"
import "animate.css"
import AnimateByScroll from "@/units/animateByScroll"

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

// const CategoryContext = React.createContext('');
// window.CategoryContext = CategoryContext

$(document).ready(function () {
  new AnimateByScroll()

  const showCategory = (category) => {
    $("[data-category-item]").each(function () {
      if ($(this).data('category-item') != category) {
        $(this).hide()
      } else {
        $(this).show()
      }
    })
  }

  let category
  let searchParams = new URLSearchParams(window.location.search)
  if (searchParams.has('category')) {
    category = searchParams.get('category')
    $(`a[data-category=${category}]`).click()
  } else {
    category = $("a.active[data-category]").data("category")
  }

  showCategory(category)

  $("a[data-category]").click(function () {
    category = $(this).data("category")
    showCategory(category)
  })




})